export const API_BASE_API_SSO_URL = process.env.REACT_APP_SSO_API;
export const API_BASE_BLOCKCHAIN_URL = process.env.REACT_APP_CHAIN_RPC_API_URL;
export const API_BASE_API_QA_URL =
  process.env.REACT_APP_CONCIERGE_URL || 'https://dev-qa-backend.transparenterra.com/api/';
